import { axiosObject } from '../setup';

function getSptRates(pairs) {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_RATES_API_URL}/rates`;
    axiosObject
      .post(uri, { type: 'SPT', pairs })
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { getSptRates };
